export default "__VITE_ASSET__B$i6Hkpe__"